module.exports = __webpack_public_path__ + "img/noContent.cd68f6ed.png";